var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardTiIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 20.0006C4.477 20.0006 0 15.5236 0 10.0006C0 4.47764 4.477 0.000640869 10 0.000640869C15.523 0.000640869 20 4.47764 20 10.0006C20 15.5236 15.523 20.0006 10 20.0006ZM10 18.0006C12.1217 18.0006 14.1566 17.1578 15.6569 15.6575C17.1571 14.1572 18 12.1224 18 10.0006C18 7.87891 17.1571 5.84408 15.6569 4.34379C14.1566 2.8435 12.1217 2.00064 10 2.00064C7.87827 2.00064 5.84344 2.8435 4.34315 4.34379C2.84285 5.84408 2 7.87891 2 10.0006C2 12.1224 2.84285 14.1572 4.34315 15.6575C5.84344 17.1578 7.87827 18.0006 10 18.0006ZM10 5.05064L14.95 10.0006L10 14.9506L5.05 10.0006L10 5.05064ZM10 7.87964L7.879 10.0006L10 12.1216L12.121 10.0006L10 7.87964Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardTiIcon);
export default __webpack_public_path__ + "static/media/dashboard_TI_icon.b74d3c5df128117180434a4ee037ffeb.svg";
export { ForwardRef as ReactComponent };